import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import classes from "./header.module.css";
import { useSelector } from "react-redux";
import EyeSpyFXLogo from '../../../assets/eyespyfx-logo.png';
import ParfasLogo from "../../../assets/parfas-logo.png"
import ResureLogo from "../../../assets/resure-logo.png"
import KnowioLogo from "../../../assets/knowio-logo.png"
import PortalLogo from "../../../assets/portal-logo.png"
import NotificationDropDownList from "../Cards/NotificationDropDownList";
import NotificationBell from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Header/__Notifications.svg"
import hambugerIcon from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Header/__Menu.svg";
import { uiActions } from "../../../store/ui-slice";
import { Link, useLocation } from "react-router-dom";
import Modal from "../../Modal/Modal";
import SetTag from "../../Modal/ModalLayouts/SetTag";
import { Audio, BallTriangle, Bars, Circles, Grid, Hearts, Oval, Puff, Rings, SpinningCircles, TailSpin, ThreeDots } from "react-loading-icons";
import { changeCamectIntegration, getGroups } from "../../../Api Methods/Api";
import { authActions } from "../../../store/auth-Slice";
import { useNavigate } from "react-router-dom";
import { serviceActions } from "../../../store/service-Slice";
import DataManager from "../../../hooks/DataManager";
import { single } from "rxjs";
import logoutIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/logout.png'
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import AddPortalUser from "../../../Pages/Groups/AddPortalUser";
import { Dropdown } from 'primereact/dropdown';
import Lottie from "lottie-react";
import successAnim from '../../../assets/animations/success.json'
import failAnim from '../../../assets/animations/fail.json'
import CreateUserForm from "../../../Pages/User Management/CreateUserForm";
import CreateUser from "../../../Register/CreateUser";
import CreateUserPortal from "../../../Register/CreateUserPortal";


const pages = ["Dashboard", "AllSites", "Offline", "Users", "Groups", "Padlocks", "Keyboxes", "Sensors", "UserSites", "Activity", "SiteView"];


const Header = ({ isSocketConnected, findClosestToEnd }) => {
    const companyName = useSelector(state => state.auth.companyName);
    const [visible, setIsVisible] = useState(false)
    const [addUserStep1Visible, setAddUserStep1Visible] = useState(false)
    const [addUserStep2Visible, setAddUserStep2Visible] = useState(false)
    const [groups, setGroups] = useState([])
    const [selectedGroup, setSelectedGroup] = useState(null)
    const [groupID, setGroupID] = useState(null)

    const [successVisible, setSuccessVisible] = useState(false)
    const [failVisible, setFailVisible] = useState(false)
    const [createUserVisible, setCreateUserVisible] = useState(false)

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const [update, setUpdate] = useState(0);

    const apiData = {
        token,
        client
    }

    const dataManager = new DataManager();

    const singleDeviceHeaderData = useSelector(state => state.service.singleDeviceHeaderData);
    const [headerData, setHeaderData] = useState(singleDeviceHeaderData);

    const dispatch = useDispatch();

    useEffect(() => {
        setHeaderData(singleDeviceHeaderData);
    }, [singleDeviceHeaderData, update])

    const ModalDialog = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    }

    const userName = useSelector(state => state.auth.userName);
    const userEmail = useSelector(state => state.auth.email);


    const userID = useSelector(state => state.auth.userID);

    const navigate = useNavigate();

    const location = useLocation();
    const pathArray = location.pathname.split('/');
    const currentpage = findClosestToEnd(pages, pathArray);
    let header;
    switch (currentpage) {

        case "Users":
        case "Activity":
        case "UserSites":
           
            break
        case "Dashboard":
            
            break
        case "AllSites":
            
            break
        case "Offline":
            
            break
        case "Groups":
            
            break
        case "Padlocks":
            
            break
        case "Sensors":
            
            break
        case "Keyboxes":
           
            break
        
        case "SiteView":
            
            break
    }

    const ShowSideNav = useSelector(state => state.ui.showSideNav);

    const handleToggleSideNav = () => {

        dispatch(uiActions.ShowSideNav(!ShowSideNav));
    }

    const LoadGroups = async () => {
        const _groups = await getGroups(apiData, dispatch)
        setGroups([..._groups].sort((a, b) =>
            a.name.localeCompare(b.name)
        ))
    }

    useEffect(() => {  
        LoadGroups()
    }, [])

    const HandleLogout = () => {
        console.log("called")
        localStorage.clear();
        navigate('/logout')
    }

    const handleReportAnIssue = () => {
        window.open("https://support.inniovate.com/portal/en/newticket", "_blank");
    }

    const HandleWhatsNew = () => {
        setIsVisible(true)
    }

    const HandleAddUser = () => {
        setAddUserStep2Visible(true)
    }

    const HandleChooseGroup = () => {
        setAddUserStep1Visible(true)
    }

    const changelogs = [
        {
            date: "Sep 25th, 2025",
            content: (
                <div className="space-y-4">
                    <h3>✨ New Features</h3>
                    <ul className="list-disc pl-5">
                    <li><strong>Mass User Creation:</strong> Upload a <code>.csv</code> file to quickly create multiple user accounts.</li>
                    <li><strong>User Onboarding Details:</strong> Profiles will now indicate whether the user joined via self-registration, an invite, or admin creation.</li>
                    <li><strong>Dashboard Improvements:</strong> Dashboard items now show an 'Active count' to compare devices on an 'active' site vs total count.</li>
                    <li><strong>Improved visibility & tracking:</strong>  
                        <ul className="list-disc pl-5">
                            <li>From now on, newly added <em>Scheduled Actions, Reminders, Site Access Restrictions, and Temporary schedules</em> will display 'Created by' and 'Date created'.</li>
                            <li>Newly added 'Devices' (AJAX, Dahua, Hikvision and AIBox) will now display 'Added by' and 'Date added' details.</li>
                        </ul>
                    </li>
                    <li><strong>User Management Enhancements:</strong>  
                        <ul className="list-disc pl-5">
                        <li>Ability to edit user names and email addresses.</li>
                        <li>Default page size on <em>Users</em> page increased to 100.</li>
                        </ul>
                    </li>
                    </ul>

                    <br></br>

                    <h3>🛠️ Improvements</h3>
                    <ul className="list-disc pl-5">
                    <li><em>Create Scheduled Action</em> now displays the pin name instead of using a clickable button.</li>
                    <li><em>Users</em> page updated: “Last logged in” column has been replaced with “Account created”.</li>
                    <li><em>Controllers</em> & <em>Offline controllers</em> page updated: Count values can now be clicked to filter the list.</li> 
                    </ul>

                    <br></br>

                    <h3>🐞 Fixes</h3>
                    <ul className="list-disc pl-5">
                    <li>Fixed logo rendering issue in the sidenav bar.</li>
                    <li>Fixed Active switch behavior on <em>Controllers</em> and <em>Offline Controllers</em> pages.</li>
                    </ul>
                </div>
            )
        },
        {
            date: "Oct 13th, 2025",
            content: (
                <div className="space-y-4">
                    <h3>✨ New Features</h3>
                    <li>   Introduced new <em>'Padlock/Keybox' entity</em> page - View detailed padlock information and configuration by clicking on a Padlock/Keybox in the <em>Padlocks</em> or <em>Keybox</em> pages </li>
                    <li>   Introduced new <em>Scheduled sites</em> page - View which sites are on schedule & up to 4 schedules per site!</li>
                    <li>   <em>App View :</em> Added 'Gateway' logo & battery level to the App View to match mobile app UI</li>
                    <li>   Added the ability to name a Padlock or Keybox, outside of the output name.</li>
                    <li>   Improved billing 
                         <ul className="list-disc pl-5">
                            <li>        • Added the ability to set a Padlock or Keybox as billable or non-billable.</li>
                            <li>        • Added the ability to assign an owner and specify who pays for each Padlock/Keybox</li>
                            <li>        • Added new billable counts for Padlocks and Keyboxes in the <em>Dashboard</em> and <em>Group</em> pages, to quickly see how many Padlocks/Keyboxes are being paid for</li>
                        </ul>
                    </li>

                    <br></br>
                    <h3>🛠️ Improvements</h3>
                    <li>    Sites set to 'Inactive' will no longer receive Smart Reminders or Scheduled Actions</li>
                    <li>    Made all pop-ups moveable by clicking and dragging on the top</li>
                    <li>    Updated table columns on <em>Padlocks</em> & <em>Keybox</em> lists</li>
                        <ul className="list-disc pl-5">
                            <li>    • "Owned by" column has been renamed to "Used by"</li>
                            <li>    • "Lock name" column now shows internal name assigned to a Padlock/Keybox, "Linked output" will show the name of the output the lock is assigned to.</li>
                            <li>    • Battery status "0%" is now displayed as "?" to match the mobile app.</li>
                        </ul>
                    <li>    Updated the text in the 'Create user' dropdown for clearer options.</li>
                    <br></br>
                    <h3>🐞 Fixes</h3>
                        <li>    Fixed an issue with <em>Rules</em> page, where removing a 'Scheduled Action' would cause the list to display in the wrong order</li>
                        <li>    Fixed an issue where the maximum length of a 'Duration' pincode would not be displayed before attempting to create</li>
                </div>
            )
        },
        {
            date: "Oct 26th, 2025",
            content: (
                <div className="space-y-4">
                    <h3>✨ New Features</h3>
                    <li>   The Portal now supports multi-tab browsing!</li>
                    <ul> You can right-click on a Site ID, Portal tab or Lock ID to open it in a new browser tab for easier multitasking</ul>
                    <li> Added ability to mass update Padlock owners from the Padlocks tab</li>
                    <li> Added ability to export Padlocks & Keyboxes to an excel file</li>
                    <br></br>
                    <h3>🛠️ Improvements</h3>
                    <li>   Added clickable link to Lock ID on Devices page, for easier navigation to Padlock page.</li>
                    <li>   Added new search & filtering options to Padlocks & Keyboxes page.</li>
                    <li>   Resolved layout issues on the Rules page for better display on smaller screens.</li>
                    <li>   Resolved layout issues with the Side nav bar for easier navigation on smaller screens</li>
                    <li>   Resolved layout issues with the Padlocks/Keyboxes/Sensors/Gateways lists on smaller screens</li>
                    <li>   Added IP Address/Site Type to user sites list</li>
                    <br></br>
                    <h3>🐞 Fixes</h3>
                    <li>    Fixed an issue preventing passcode creation on Padlocks.</li>
                    <li>    Fixed a bug where bookmarking the Portal could cause it to crash on launch.</li>
                </div>
            )
        },
        {
            date: "Nov 17th, 2025",
            content: (
                <div className="space-y-4">
                    <h3>✨ New Features</h3>
                    <li>   Added the ability to edit schedules from the <em>Scheduled sites</em> page!</li>
                    <ul> Simply click on an Arm or Disarm schedule to edit the execution time & days</ul>
                    <li> Added 'Last update' date to edited schedules to easily keep track of which have been modified already</li>
                    <li>   Added new <em>Live view enabled</em> page!</li>
                    <ul> Easily view sites with cameras linked, as well as when they were linked & by whom!</ul>
                    <li> Added Inniovate only Live View switch to allow setting of Live View licence per site</li>
                    <br></br>
                    <h3>🛠️ Improvements</h3>
                    <li>   Greyed out inactive sites on site lists to easily distinguish those that are active</li>
                    <li>   Changed app view icon to 'Settings cog' instead of Pencil</li>
                    <li>   Resolved layout issues on the Rules page for better display on smaller screens.</li>
                    <li>   Added linked camera count to Overview page of Live View enabled sites</li>
                    <li>   Added Live View stats to Dashboard & Group Dashboards - count of Live View enabled sites & no. of cameras linked</li>
                    <li>   Added camera & site counts to new <em>Live view enabled</em> page</li>
                    <li>   Updated <em>Scheduled sites</em> page to allow filtering by day of execution</li>
                    <li>   Changed 'Holiday mode' to 'Temporary Schedules' throughout</li>
                    <br></br>
                    <h3>🐞 Fixes</h3>
                    <li>    Fixed an issue with selecting page size on site event logs.</li>
                    <li>    Fixed an issue where G2CC sites showed as 'Physical Controller' on Overview page</li>
                    <li>    Fixed an issue where some duration codes didn't display the end date & which pin type was created</li>
                    <li>    Fixed issue with Portal name not updating on App UI after 1st change</li>
                    <li>    Fixed issue with Reminders showing as a Schedule</li>
                    <li>    Fixed issue with create mass/individual temporary schedule</li>
                </div>
            )
        },
        {
            date: "Nov 25th, 2025",
            content: (
                <div className="space-y-4">
                     <h3>✨ New Features</h3>
                    <li>   Ganz AiBox V2 is here!</li>
                    <ul> You can now control your Ganz AiBox Channels, Rules, Relays or the whole Hub!</ul>
                    <li>   Added new 'Give Portal access' button to the header bar to easily grant access to the Portal</li>
                    <br></br>
                    <h3>🛠️ Improvements</h3>
                    <li>   Completely reworked Active Sites, Inactive Sites, Controllers & Sites on schedule to reduce load times and increase responsiveness</li>
                    <li>   Updated 'Add to group' dropdown menus. They're now searchable with an improved UI</li>
                    <li>   Account username & email address is now displayed in the header bar</li>
                    <li>   Reworked Live view enabled page to be site orientated</li>
                    <li>   Added ability to click on 'Camera count' on Live view sites to show list of linked cameras</li>
                    <li>   Redesigned Devices & Rules layouts due to rendering issues</li>
                    <br></br>
                    <h3>🐞 Fixes</h3>
                    <li>    Fixed an issue with incorrect error messages being shown when inviting a user</li>
                    <li>    Fixed an issue with searching on the Active & Inactive sites tab</li>
                   <li>     Fixed an issue with duplicate schedules appearing after creating a 'Temporary schedule'</li>
                </div>
            )
        }
    ]

    const [selected, setSelected] = useState(changelogs[4]);

    const HandleNext = () => {
        console.log(selectedGroup)
        setGroupID(selectedGroup.id)
        setAddUserStep1Visible(false)
        setAddUserStep2Visible(true)
    }

    const HandleCreateUser = () => {
        setAddUserStep2Visible(false)
        setFailVisible(false)
        setCreateUserVisible(true)
    }

    return (
        <>
            <Modal ref={ModalDialog} title={"Tag site - " + headerData.key} modalName={"Site View"} HandleShowModal={HandleShowModal}>
                <SetTag placeholder={headerData.key} DeviceUUID={headerData.uuid} HandleCloseModal={HandleCloseModal} dispatch={dispatch} update={update} setUpdate={setUpdate} isManualSet={true} headerData={headerData} setHeaderData={setHeaderData}/>
            </Modal>

        <Dialog
            header="Changelog"
            visible={visible}
            style={{ width: "60vw" }}
            onHide={() => setIsVisible(false)}
            >
            <div className="flex gap-4">
                {/* Sidebar selector */}
                <div className="flex flex-col gap-2 w-1/4 border-r pr-2">
                {changelogs.map((log) => (
                    <Button
                    label={log.date} 
                    severity="help"
                    outlined={selected.date !== log.date} 
                    rounded
                    key={log.date}
                    onClick={() => setSelected(log)}
                    style={{marginRight:"10px", marginBottom:"20px"}}
                    />
                    
                   
                ))}
                </div>

                {/* Content */}
                <div className="w-3/4 pl-4" style={{margin:"15px"}}>{selected.content}</div>
            </div>
        </Dialog>

        <Dialog
            header="Give Portal access"
            visible={addUserStep2Visible}
            style={{ width: "40vw" }}
            onHide={() => setAddUserStep2Visible(false)}
            >
            <div className="flex gap-4">
               <AddPortalUser setSuccess={setSuccessVisible} setFail={setFailVisible} groupID={groupID} setShowPrevDialogs={setAddUserStep2Visible} />
            </div>
        </Dialog>

        <Dialog
            header="Which group will they have access to?"
            visible={addUserStep1Visible}
            style={{ width: "40vw" }}
            onHide={() => setAddUserStep1Visible(false)}
            >
            <div>
            {/* Choose group */}
               <p>Choose group from the dropdown below</p>
               <Dropdown 
                value={selectedGroup} 
                onChange={(e) => setSelectedGroup(e.value)} 
                options={groups} 
                optionLabel="name"
                showClear
                filter
                placeholder="Select a group" 
                className="w-full md:w-14rem" />

            </div>

            <br></br>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button label="Next" severity="success" disabled={!selectedGroup} onClick={HandleNext} />
            </div>
        </Dialog>

        <Dialog
            header="Success"
            visible={successVisible}
            style={{ width: "40vw" }}
            onHide={() => setSuccessVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff"}}>User added successfully!.</h3>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />

                <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setSuccessVisible(false)}/>
            </div>
        </Dialog>

        <Dialog
            header="Error"
            visible={failVisible}
            style={{ width: "40vw" }}
            onHide={() => setFailVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff", textAlign: "center"}}>Failed to add user, please try again.</h3>
     
            <p style={{color:"#6e6e6eff", textAlign: "center"}}>Please note, users must have an existing app account to be invited to the Admin Portal.</p>
                <Lottie
                    animationData={failAnim}
                    loop={false}
                    style={{ width: 200, height: 200, margin: "0px" }}
                />

            <Button label="Close" rounded severity="primary" icon="pi pi-times"onClick={() => setFailVisible(false)}/>
                <br></br>
            <Button label="Create user?" icon="pi pi-info-circle" severity="secondary" onClick={HandleCreateUser}/>


            </div>
        </Dialog>

        <Dialog
            header="Give Portal access"
            visible={createUserVisible}
            style={{ width: "40vw" }}
            onHide={() => setCreateUserVisible(false)}
            >
            <div className="flex gap-4">
                <CreateUserPortal setSuccessVisible={setSuccessVisible} setFailVisible={setFailVisible} setCreateAccountVisible={setCreateUserVisible} groupID={groupID} />
            </div>
        </Dialog>



            <div className={classes['header-container']}>
                <img className={classes.hambugerIcon} src={hambugerIcon} onClick={handleToggleSideNav} />
                <div className={classes.innerContainer}>
                    <div className={classes.container}>
                        <p style={{fontSize:"12px", color:"#6e6e6e"}}>{`Logged in as: ${userName} - (${userEmail})`}</p> 
                    </div>
                    <div className={classes.right} style={{cursor: "pointer", display: "flex", alignItems: "center", gap: "10px"}}>
                    {/* <Button severity="secondary" className={classes.headerButton} label="Report an issue" icon="pi pi-send" onClick={handleReportAnIssue}/> */}
                    <Button severity="info" className={classes.headerButton} label="Give Portal access" icon="pi pi-user-plus" onClick={HandleChooseGroup}/>
                    <Button severity="help" outlined className={classes.headerButton} label="What's new?" icon="pi pi-sparkles" onClick={HandleWhatsNew}/>
                    <Button severity="secondary" className={classes.headerButton} label="Logout" icon="pi pi-sign-out" onClick={HandleLogout}/>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Header;